export { default as Img200 } from './processed/200/True-Detective-S3.jpg';
export { default as Img400 } from './processed/400/True-Detective-S3.jpg';
export { default as Imgthumb } from './processed/thumb/True-Detective-S3.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/True-Detective-S3.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/True-Detective-S3.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      52,
      183,
      186
    ],
    "_population": 1324,
    "_hsl": [
      0.503731343283582,
      0.5630252100840335,
      0.4666666666666667
    ]
  },
  "LightVibrant": {
    "_rgb": [
      165,
      203,
      212
    ],
    "_population": 392,
    "_hsl": [
      0.5319148936170214,
      0.3533834586466167,
      0.7392156862745098
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      111,
      72,
      33
    ],
    "_population": 2145,
    "_hsl": [
      0.08333333333333331,
      0.5416666666666667,
      0.2823529411764706
    ]
  },
  "Muted": {
    "_rgb": [
      181,
      155,
      107
    ],
    "_population": 2527,
    "_hsl": [
      0.10810810810810806,
      0.3333333333333334,
      0.5647058823529412
    ]
  },
  "LightMuted": {
    "_rgb": [
      171,
      199,
      197
    ],
    "_population": 2425,
    "_hsl": [
      0.48809523809523814,
      0.20000000000000004,
      0.7254901960784313
    ]
  },
  "DarkMuted": {
    "_rgb": [
      47,
      37,
      35
    ],
    "_population": 1984,
    "_hsl": [
      0.027777777777777776,
      0.14634146341463414,
      0.1607843137254902
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/True-Detective-S3.js